module.exports = __webpack_public_path__ + "img/footer-medium.075ad252.svg";